export const BackgroundBlobs = () => {
    return (
        <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
            {/* Purple blob - top right */}
            <div 
                className="absolute -top-40 -right-40 w-[600px] h-[600px] bg-purple-200/40 rounded-full blur-3xl animate-blob"
                style={{ borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%' }}
            />
            
            {/* Green blob - bottom left */}
            <div 
                className="absolute -bottom-40 -left-40 w-[500px] h-[500px] bg-green-200/30 rounded-full blur-3xl animate-blob-delay-1"
                style={{ borderRadius: '40% 60% 70% 30% / 40% 70% 30% 60%' }}
            />
            
            {/* Indigo blob - center */}
            <div 
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-indigo-100/40 rounded-full blur-3xl animate-blob-delay-2"
                style={{ borderRadius: '30% 70% 40% 60% / 50% 40% 60% 50%' }}
            />
            
            {/* Small accent blobs */}
            <div 
                className="absolute top-1/4 right-1/4 w-[200px] h-[200px] bg-purple-300/20 rounded-full blur-2xl animate-blob-delay-1"
            />
            <div 
                className="absolute bottom-1/4 left-1/3 w-[250px] h-[250px] bg-green-300/20 rounded-full blur-2xl animate-blob-delay-2"
            />
        </div>
    );
};

export default BackgroundBlobs;
